// data-testid registry for UtilityTool UI

export const NAV = {
    logo: 'nav-logo-link',
    categoriesMenu: 'nav-categories-menu',
    searchInput: 'header-search-input',
    mobileMenuTrigger: 'nav-mobile-trigger',
    ctaBrowseTools: 'nav-cta-browse-tools',
};

export const FOOTER = {
    aboutLink: 'footer-about-link',
    contactLink: 'footer-contact-link',
    privacyLink: 'footer-privacy-link',
    termsLink: 'footer-terms-link',
    blogLink: 'footer-blog-link',
    toolsLink: 'footer-tools-link',
};

export const HOME_PAGE = {
    hero: 'home-hero',
    heroSearch: 'home-hero-search-input',
    heroCta: 'home-hero-cta-browse',
    featuredTools: 'home-featured-tools',
    categoryGrid: 'home-category-grid',
    latestBlog: 'home-latest-blog',
};

export const TOOL_HUB = {
    search: 'tool-hub-search-input',
    grid: 'tool-hub-grid',
    chipAll: 'tool-hub-chip-all',
    emptyState: 'tool-hub-empty',
};

export const TOOL_CARD = (slug) => `tool-card-${slug}`;
export const TOOL_OPEN = (slug) => `tool-card-open-${slug}`;

export const TOOL_PAGE = {
    fileInput: 'tool-file-input',
    dropzone: 'tool-dropzone',
    runButton: 'tool-run-button',
    resetButton: 'tool-reset-button',
    downloadButton: 'tool-download-button',
    qualitySlider: 'tool-quality-slider',
    resultCard: 'tool-result-card',
    errorAlert: 'tool-error-alert',
};

export const BLOG = {
    listGrid: 'blog-list-grid',
    cardLink: (slug) => `blog-card-link-${slug}`,
    article: 'blog-article',
};

export const CONTACT = {
    formName: 'contact-form-name',
    formEmail: 'contact-form-email',
    formTopic: 'contact-form-topic',
    formMessage: 'contact-form-message',
    submit: 'contact-form-submit-button',
    success: 'contact-form-success',
};
